import { getFormattedDate } from "@/helpers";
import styles from "./GeneralInfo.module.sass";

interface GeneralInfoProps {
  addressDetailsData?: Record<string, any> | null;
  addressOwner?: string | null;
  isLoading?: boolean;
}

export const GeneralInfo = ({
  isLoading,
  addressDetailsData,
  addressOwner,
}: GeneralInfoProps) => {
  if (!addressDetailsData) {
    return null;
  }

  const firstChange = addressDetailsData.first_tx
    ? getFormattedDate(addressDetailsData.first_tx)
    : "";
  const lastChange = addressDetailsData.last_tx
    ? getFormattedDate(addressDetailsData.last_tx)
    : "";
  const countTransactions = addressDetailsData.n_txs || "";

  if (!firstChange && !lastChange && !countTransactions) {
    return null;
  }

  if (isLoading) {
    return (
      <div className={styles.box}>
        <div className={styles.skeleton}>
          <div className={styles.skeletonTitle} />
          <div className={styles.skeletonLine} />
          <div className={styles.skeletonLine} />
        </div>
      </div>
    );
  }

  return (
    <div className={styles.general}>
      <div className={styles.title}>General Info</div>

      <div className={styles.list}>
        {addressOwner && (
          <dl>
            <dt>Belongs to cluster:</dt>
            <dd>{addressOwner}</dd>
          </dl>
        )}
        {firstChange && (
          <dl>
            <dt>First Balance Change:</dt>
            <dd>{firstChange}</dd>
          </dl>
        )}

        {lastChange && (
          <dl>
            <dt>Last Balance Change:</dt>
            <dd>{lastChange}</dd>
          </dl>
        )}

        {countTransactions && (
          <dl>
            <dt>Transactions:</dt>
            <dd>{countTransactions}</dd>
          </dl>
        )}
      </div>
    </div>
  );
};
